import React from 'react';
import { convertToRaw } from 'draft-js';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import { DragDropContext } from 'react-beautiful-dnd';
import draftToHtml from 'draftjs-to-html';

import DropArea from 'components/DragAndDrop/DropArea';
import AccordionItem from './AccordionItem';

import classes from './AccordionEditor.module.scss';

const AccordionEditor = ({
  items = [],
  onItemsChange,
  onDelete,
  selectedLanguage,
}) => {
  const handleTitleChange = (index, value) => {
    const newItems = items.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          title: {
            ...item.title,
            content: {
              ...item.title.content,
              [selectedLanguage]: value,
            },
          },
        };
      }
      return item;
    });
    onItemsChange(newItems);
  };

  const handleBodyChange = (index, editorState) => {
    const content = editorState.getCurrentContent();
    const plainText = content.getPlainText();
    const html = draftToHtml(convertToRaw(content));

    const newItems = items.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          body: {
            ...item.body,
            content: {
              ...item.body.content,
              [selectedLanguage]: plainText,
            },
            richText: {
              ...item.body.richText,
              [selectedLanguage]: html,
            },
          },
        };
      }
      return item;
    });

    onItemsChange(newItems);
  };

  const toggleOpen = (index) => {
    const newItems = items.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          open: !item.open,
        };
      }
      return item;
    });
    onItemsChange(newItems);
  };

  const addItem = () => {
    const newItem = {
      id: uuid(),
      title: {
        content: { [selectedLanguage]: '' },
      },
      body: {
        content: { [selectedLanguage]: '' },
        richText: { [selectedLanguage]: '' },
      },
      open: false,
    };
    onItemsChange([...items, newItem]);
  };

  const onDragEnd = ({ destination, source }) => {
    if (!destination) return;

    const newItems = Array.from(items);
    const [removed] = newItems.splice(source.index, 1);
    newItems.splice(destination.index, 0, removed);

    onItemsChange(newItems);
  };

  return (
    <div className={classes['accordion-container']}>
      <div className={classes['accordion-header']}>
        <h2 className={classNames('subtitle', classes.subtitle)}>Accordion</h2>
        <button type="button" className="button" onClick={onDelete}>
          <span className="icon is-small">
            <i className="mdi mdi-delete" />
          </span>
        </button>
      </div>
      <DragDropContext onDragEnd={onDragEnd}>
        <DropArea dropId="accordion-items" type="accordion">
          <div className={classes['accordion-items-container']}>
            {items.map((item, index) => (
              <AccordionItem
                key={item.id}
                item={item}
                index={index}
                selectedLanguage={selectedLanguage}
                onTitleChange={handleTitleChange}
                onBodyChange={handleBodyChange}
                onToggleOpen={toggleOpen}
              />
            ))}
          </div>
        </DropArea>
      </DragDropContext>
      <button
        className={classNames('button', classes['new-item-button'])}
        type="button"
        onClick={addItem}
      >
        Add New Item
      </button>
    </div>
  );
};

export default AccordionEditor;
